import { useEffect, useRef, useState } from 'react';

export type Regions = 'eu' | 'us';
type Config = {
  region: Regions;
  stageVersion: string;
  releaseDate: string;
  udiCompanyIdentifier: string;
  copyright: string;
  swissAddress: string;
};

type RefState =
  | {
      type: 'not started';
    }
  | {
      type: 'pending';
    }
  | {
      type: 'success';
  };

export const SwissLanguages = ['de', 'fr', 'it'];

export const useConfiguration = () => {
  const configRef = useRef<RefState>({ type: 'not started' });
  const [state, setState] = useState<Config>();
  useEffect(() => {
    const load = async () => {
      configRef.current = {
        type: 'pending',
      };
      const response = await fetch('/infohub/config.json');
      const result = await response.json();
      configRef.current = {
        type: 'success',
      };
      setState(result);
    };
    if (configRef.current.type === 'not started') {
      load();
    }
  }, []);
  return state;
};
